/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is SILENT an anagram of LISTEN?`)
};

const es_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Es SILENT un anagrama de LISTEN?`)
};

const de_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ist SILENT ein Anagramm von LISTEN?`)
};

const nl_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is SILENT een anagram van LISTEN?`)
};

const fr_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT est-il une anagramme de LISTEN ?`)
};

const it_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT è un anagramma di LISTEN?`)
};

const pt_br2_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT é um anagrama de LISTEN?`)
};

const pt_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT é um anagrama de LISTEN?`)
};

const ja_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENTはLISTENのアナグラムですか？`)
};

const zh_wu_c_listen_faq2_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SILENT 是 LISTEN 的易位构词吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const wu_c_listen_faq2_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.wu_c_listen_faq2_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("wu_c_listen_faq2_q", locale)
	if (locale === "en") return en_wu_c_listen_faq2_q(inputs)
	if (locale === "es") return es_wu_c_listen_faq2_q(inputs)
	if (locale === "de") return de_wu_c_listen_faq2_q(inputs)
	if (locale === "nl") return nl_wu_c_listen_faq2_q(inputs)
	if (locale === "fr") return fr_wu_c_listen_faq2_q(inputs)
	if (locale === "it") return it_wu_c_listen_faq2_q(inputs)
	if (locale === "pt-BR") return pt_br2_wu_c_listen_faq2_q(inputs)
	if (locale === "pt") return pt_wu_c_listen_faq2_q(inputs)
	if (locale === "ja") return ja_wu_c_listen_faq2_q(inputs)
	return zh_wu_c_listen_faq2_q(inputs)
};